import {Tabs} from "@variocube/app-ui";
import React from "react";
import {useLocalization, useWordingFlavor} from "@smalox/shared";
import {useSearchParam} from "../../utils/search";
import {View, ViewHeader} from "../View";
import {AuditSettings} from "./AuditSettings";
import {TenantBookingSettings} from "./TenantBookingSettings";
import {TenantCompartmentSettings} from "./TenantCompartmentSettings";
import {TenantGeneralSettings} from "./TenantGeneralSettings";
import {TenantLegalSettings} from "./TenantLegalSettings";
import {TenantSubscriptions} from "./TenantSubscriptions";
import {TenantSupportSettings} from "./TenantSupportSettings";

export function Settings() {
	const {t} = useLocalization();
	const wordingFlavor = useWordingFlavor();
	const [tab, setTab] = useSearchParam("tab", "general");
	return (
		<View>
			<ViewHeader
				title={t("settings.title")}
			/>
			<Tabs
				value={tab}
				onChange={(_, tab) => setTab(tab)}
				items={[
					{label: t("tenants.single"), value: "general"},
					{label: t(`bookings.title.${wordingFlavor}`), value: "booking"},
					{label: t("audit.title"), value: "audit"},
					{label: t(`compartments.title.${wordingFlavor}`), value: "compartment"},
					{label: t("settings.support.title"), value: "support"},
					{label: t("settings.legal.title"), value: "legal"},
					{label: t("subscriptions.title"), value: "subscriptions"},
				]}
			/>
			{tab == "general" && <TenantGeneralSettings />}
			{tab == "booking" && <TenantBookingSettings />}
			{tab == "audit" && <AuditSettings />}
			{tab == "compartment" && <TenantCompartmentSettings />}
			{tab == "support" && <TenantSupportSettings />}
			{tab == "legal" && <TenantLegalSettings />}
			{tab == "subscriptions" && <TenantSubscriptions />}
		</View>
	);
}
